export default {
	apiUrl:{
        //会员管理
        memberUrl : {
            getMemberList:'/member/mgmt/list',//会员列表
            operateLog:'/member/mgmt/log/list',//操作日志
            forbidden:'member/mgmt/forbidden',//会员冻结
            relieve:'/member/mgmt/relieve',//会员解冻
            wholeInfo:'/member/mgmt/wholeInfo',//详情页
            list:'/member/address/mgmt/list/',//地址列表
            queryOrder:'/giftcard/order/query',//礼卡订单
            queryConsume:'/giftcard/unit/query',//礼卡管理
            detail:'/giftcard/unit/detail/',//礼卡详情
            queryOrders:'/trade/platform/queryOrders',//订单列表
            consumeLog:'/giftcard/unit/consumeLog',/*礼卡消费记录详情*/
            refundPage:'/trade/refund/platform/refundPage',//售后列表
            getPointLogList:"/member/point/mgmt/getPointLogList",   /**积分变动日志 */
            getConverLogList:"/member/point/mgmt/getConverLogList",  /**积分转换 */
            all:'/giftcard/label/all',//礼卡类型
            getPointOpTypeList:'/member/point/mgmt/getPointOpTypeList',//积分类型
            redressPoint:'/member/point/mgmt/redressPoint',//积分补录
            showAsset:"/member/point/mgmt/showAsset/",
            getBalanceOpTypeList:'/member/point/mgmt/getBalanceOpTypeList',/* 获取余额变动类型列表 */
            getBalanceLogList:'/member/point/mgmt/getBalanceLogList',/* 分页查询余额流水明细 */
            excelMemberInfo:"/member/mgmt/export/baseInfo", //导出会员信息
            vipInvitation:"/member/mgmt/export/vipInvitation",    //导出用户关联关系
            showVipInvitation:"/member/mgmt/show/vipInvitation",    //会员信息展示
            audit:'/member/enterprise/audit',// 审核
            newtypeConfig:'/member/get/newtype/config',// 获取会员等级配置
            updateLog:'/member/mgmt/get/new/updateLog',//获取新体系会员升级日志
            invatationList:'/member/get/invatation/list',//查看邀请列表
        },
        //申诉管理
        complaintUrl:{
            list:'/member/appeal/mgmt/list',//列表页
            detail:'/member/appeal/mgmt/detail/',//详情页
            check:'/member/appeal/mgmt/check',//审核
        },
        // 注册登录限制管理
        memberLimitUrl:{
            findIsCaptchaLimitByPhone:'/system/captchaLimitResolve/findIsCaptchaLimitByPhone/',/* 根据手机号查询发送验证码是否被限制 */
            findIsLoginLimit:'/system/captchaLimitResolve/findIsLoginLimit/',/* 根据手机号或用户名查询登陆是否被限制 */
            resolveLoginLimit:'/system/captchaLimitResolve/resolveLoginLimit/',/* 根据手机号或用户名解除登陆限制 */
            resolveCaptchaLimit:'/system/captchaLimitResolve/resolveCaptchaLimit/',/* 根据手机号解除验证码限制 */
            findOperateLog:'/system/captchaLimitResolve/findOperateLog',/* 根据类型查询解除限制操作日志 */
        }
    }
}
